/**
 * ResponsavelConfigSmsCollection
 *
 * @author Simpli CLI generator
 */
import {PageCollection, HttpExclude, Request} from 'simpli-web-sdk'
import {ResponsavelConfigSms} from '@/model/resource/ResponsavelConfigSms'

/* TODO: review generated class */
@HttpExclude()
export class ResponsavelConfigSmsCollection extends PageCollection<
  ResponsavelConfigSms
> {
  constructor() {
    super(ResponsavelConfigSms)
  }

  queryAsPage() {
    return this.listResponsavelConfigSms()
  }

  async listResponsavelConfigSms() {
    return await Request.get(`/admin/responsavel-config-sms`, {
      params: this.params,
    })
      .name('listResponsavelConfigSms')
      .as(this)
      .getResponse()
  }

  async listCsvResponsavelConfigSms() {
    return await Request.get(`/admin/responsavel-config-sms/csv`, {
      params: this.params,
    })
      .name('listCsvResponsavelConfigSms')
      .as(this)
      .getResponse()
  }
}
